<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">Contents</p>
<p class="toc1"><a href="#/xhtml/05_Introduction"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/xhtml/06_Abbreviations"><i>Abbreviations</i></a></p>
<p class="toc1a"><a href="#/xhtml/07_Chapter01">1.  General Sir Archibald P. Wavell’s Despatch on Operations in Burma, 15 December to 20 May 1942</a></p>
<p class="toc1"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">2.  General Sir Archibald P. Wavell’s Despatch on Operations in the Eastern Theatre, based on India, March 1942 to 31 December 1942</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">3.  Field Marshal Viscount Wavell’s Despatch on Operations in the India Command, 1 January to 29 June 1942</span></p>
<p class="toc1"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">4.  Field Marshal Sir Claude J.E. Auchinleck’s Despatch on Operations in the Indo-Burma Theatre, based on India, 21 June to 15 November 1943</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?0dd5f46e